import type { Editor } from '@aitomol/core';
import { createAitomolEditor } from '@aitomol/react';

/**
 * Editor factory for the platform's 3D pane.
 *
 * `createAitomolEditor()` already registers every built-in format (XYZ, extXYZ,
 * MOL, SDF, PDB, GRO, cube, Gaussian, MOL2, PQR), tool, representation and
 * colour theme, so the platform adds nothing here - it only pins the options that
 * matter for lab work.
 *
 * The backend is deliberately left to `MoleculeCanvas`: it owns that lifecycle,
 * and creating one here would mean disposing it by hand on every unmount.
 */
export function createPlatformEditor(): Editor {
    return createAitomolEditor({
        // Optimisation logs and edited structures produce long command streams.
        historyLimit: 300
    });
}